import { EntityRepository, Repository } from "typeorm";
import { Peeling } from "../entities/peeling.entity";

@EntityRepository(Peeling)
export class PeelingRepository extends Repository<Peeling> {

}